import { createQueryHook } from '@hooks/createQueryHook'

// Current jackpot for the brand. No params.
export const useCurrentJackpot = createQueryHook('jackpot.current')

// Current jackpot with the player's contribution. No params.
export const useCurrentJackpotUserSpecific = createQueryHook('jackpot.currentUserSpecific')

// The player's tickets for a jackpot. Component passes { jackpotId }.
export const useJackpotTickets = createQueryHook('jackpot.tickets')

// Top contributions (leaderboard + current user). No params.
export const useTopJackpotContributions = createQueryHook('jackpot.topContributions')

// Prize distribution for a jackpot. Component passes { jackpotId }.
export const useJackpotPrizeDistribution = createQueryHook('jackpot.prizeDistribution')

// The player's contributions to a jackpot. Component passes { jackpotId }.
export const useJackpotContributions = createQueryHook('jackpot.contributions')

// The player's jackpot history. No params.
export const useJackpotHistory = createQueryHook('jackpot.history')

// Results of a settled jackpot. Component passes { jackpotId }.
export const useJackpotHistoryResults = createQueryHook('jackpot.historyResults')
